import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { EmbedVideoService } from 'ngx-embed-video';

// function randomInt() { //defining the randomizer function
//   var video;
//   video[ Math.floor(Math.random() * 10) ]['vimeoID']   //this is the randomizer, 0-9
// }

//declare var require: any // this added just to try to deal with reload issue
//var works: string; // this added just to try to deal with reload issue


@Component({
  selector: 'app-videostreamer-details',
  templateUrl: './videostreamer-details.component.html',
  styleUrls: ['./videostreamer-details.component.css']
})
export class VideostreamerDetailsComponent implements OnInit {

	works = require('../../../assets/data/data.json');
	work;
	vimeoID: string;
  vimeoEmbedString: string;

  constructor(
    private route: ActivatedRoute,
    private embedService: EmbedVideoService
  ) { 
    for (let work of this.works) {
  	  if (work.slug == this.route.snapshot.paramMap.get("slug")) {
  		  this.work = work;
  	  }
    }
  
    if (this.work.vimeoID) {
      this.vimeoEmbedString = this.embedService.embed_vimeo(this.work.vimeoID, {
		  query: { controls: true, byline: false, portrait: false, playsinline: true},
		  //you can add "autoplay: true, muted: true" to the above for pre-muted autoplay...
	      attr: { width: 1280, height: 720 }
      });	
    }
  }
  

  ngOnInit() {
    // randomInt()
  }

}
